import { useQuery } from "@apollo/client";
import { Channel } from "@/schemaTypes";
import { ChannelByUsernameDocument } from "../graphql/channelByUsername.generated";
import { useEventRefetch } from "../events";
import { noCacheHeaders } from "@/utils/headers";
import { useHomepageSsr } from "@/providers/HomepageSsrProvider";

export const useGetChannelByUsername = (username?: string) => {
  const { channelDetail, isSsrChannelDetail } = useHomepageSsr();
  const hasMatchingServerResult = Boolean(
    username &&
      isSsrChannelDetail &&
      channelDetail?.channelResolved &&
      channelDetail.requestedUsername === username
  );
  const { data, loading, refetch } = useQuery(ChannelByUsernameDocument, {
    variables: { username: username! },
    skip: !username || hasMatchingServerResult,
    fetchPolicy: "no-cache",
    context: { headers: noCacheHeaders },
  });

  useEventRefetch("channelUpdated", refetch);

  const channel: Channel | undefined =
    data !== undefined
      ? data.channelByUsername ?? undefined
      : hasMatchingServerResult
      ? channelDetail?.channel ?? undefined
      : undefined;

  return { channel, loading: hasMatchingServerResult ? false : loading };
};
